<template>
    <div>
        <div class="mb-3 text-right">
            <hts-form-button
                v-if="checkPermission(layoutPermissions['partner_add'])"
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="openAddCooperator">
                {{ $t('labels.add') }}
            </hts-form-button>

            <hts-form-button
                v-if="checkPermission(layoutPermissions['partner_add'])"
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="openInvitePartner">
                <!-- {{ $t('labels.add') }} -->
                Mời đội xe
            </hts-form-button>
        </div>
        <hts-data-table
            ref="dataTables"
            store-name="cooperatorDataTable"
            store-key="Cooperator"
            :use-archive="useArchive"
            :use-restore="useRestore"
            use-selection
            :headers="customerHeaders"
            :server="apiListCooperator" />

        <add-partner
            v-if="checkPermission(layoutPermissions['partner_add'])"
            ref="addCooperator"
            @refresh-tables="refreshTables()" />

        <InvitePartner
            v-if="checkPermission(layoutPermissions['partner_add'])"
            ref="invitePartner"
            @refresh-tables="refreshTables()" />

        <detail-partner
            v-if="checkPermission(layoutPermissions['partner_management'])"
            ref="detailCooperator" />

        <hts-modal
            v-if="checkPermission(layoutPermissions['partner_delete'])"
            :show="showPopupDeleteCustomer"
            :title="$t('labels.deleteCooperator')"
            type="confirm"
            :content="$t('labels.confirmDeleteCustomer')"
            @hide="showPopupDeleteCustomer = false"
            @confirm="actionDeleteCustomer" />
        <router-view :refresh-tables="refreshTables" />
    </div>
</template>

<script setup lang="ts">
import actions from './partner/-components/actions.vue'
import AddPartner from './partner/-components/add.vue'
import CooperatorLabel from './partner/-components/cooperator-label.vue'
import DetailPartner from './partner/-components/detail.vue'
import InvitePartner from './partner/-components/invite.vue'
import SystemParticipationStatus from './partner/-components/tabels/system-participation-status.vue'
import { IDataCooperator } from '~/pages/trucker-[id]/partner/-components/imports/form'
import Status from '~/components/status.vue'
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '@/data/permissions/layout-permissions'

const { $formatters } = useNuxtApp()
const { $t } = useNuxtApp()

const dataTables = ref()
const customerIsSelectedForEdit = ref({})
const showSlideOverAddDocumentCustomer = ref(false)
const showPopupDeleteCustomer = ref(false)
const customerIsSelectedForDelete = ref<IDataCooperator | null>()

const codePartner = ref()
const refreshTables = () => {
  if (dataTables.value) {
    dataTables.value.refresh()
  }
}

const openListBusinessOpportunity = (partner: IDataCooperator) => {
  useRouter().push({ name: 'trucker-id-partner-idpartner-business-opportunity', params: { idpartner: partner._id } })
}

const apiListCooperator = $url.partner['get-list']

const openListCommodity = (partner: IDataCooperator) => {
  useRouter().push({ name: 'trucker-id-partner-idpartner-commodity', params: { idpartner: partner._id } })
}

const openListContact = (partner: IDataCooperator) => {
  useRouter().push({ name: 'trucker-id-partner-idpartner-contact', params: { idpartner: partner._id } })
}
const openListInvoicingInformation = (partner: IDataCooperator) => {
  useRouter().push({ name: 'trucker-id-partner-idpartner-invoicing-information', params: { idpartner: partner._id } })
}

const openListBank = (partner: IDataCooperator) => {
  useRouter().push({ name: 'trucker-id-partner-idpartner-bank', params: { idpartner: partner._id } })
}

const openTaskCompletionTime = (partner: IDataCooperator) => {
  useRouter().push({ name: 'trucker-id-partner-idpartner-task-completion-time', params: { idpartner: partner._id } })
}

const addCooperator: any = ref(null)
const invitePartner: any = ref(null)

const openAddCooperator = () => {
  if (addCooperator.value) {
    addCooperator.value.open()
  }
}

const openInvitePartner = () => {
  if (invitePartner.value) {
    invitePartner.value.open()
  }
}

const editCooperator: any = ref(null)

const validateListCommodity = (partner: IDataCooperator) => {
  return partner.type.includes('CUSTOMER')
}
const validateListBusinessOpportunity = (partner: IDataCooperator) => {
  return partner.type.includes('CUSTOMER')
}

const handleEditCustomer = (cooperator: IDataCooperator) => {
  useRouter().push({ name: 'trucker-id-partner-idpartner-edit', params: { idpartner: cooperator._id } })
}
const detailCooperator: any = ref(null)

const handleViewDetailCustomer = (cooperator: IDataCooperator) => {
  customerIsSelectedForEdit.value = { ...cooperator }
  if (detailCooperator.value) {
    detailCooperator.value.open(cooperator._id)
  }
}

const handleDeleteCustomer = (partner: IDataCooperator) => {
  showPopupDeleteCustomer.value = true
  customerIsSelectedForDelete.value = { ...partner }
}

const handleShowDocumentCooperator = (partner: IDataCooperator) => {
  codePartner.value = partner?._id
  useRouter().push({ name: 'trucker-id-partner-idpartner-document', params: { idpartner: partner._id } })
}

const customerHeaders = ref([
  {
    field: 'name',
    headerName: $t('labels.name'),
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'abbreviationName',
    headerName: $t('labels.abbreviationName'),
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'email',
    headerName: $t('labels.emailAddress'),
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'phone',
    headerName: $t('labels.phone'),
    valueFormatter: (params: any) => {
      const code = params?.data?.phone?.code || ''
      const phone = params?.data?.phone?.phone || ''
      return code ? `(${code}) ${phone}` : phone
    }
  },
  {
    field: 'type',
    headerName: $t('labels.type'),
    cellRenderer: CooperatorLabel,
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      { name: $t('labels.customer'), value: 'CUSTOMER', class: { '!bg-pink-100': true, '!text-pink-800': true } }, // Customer: Màu hồng
      { name: $t('labels.partner'), value: 'PARTNER', class: { '!bg-blue-100': true, '!text-blue-800': true } }, // Partner: Màu xanh dương
      { name: $t('labels.vendor'), value: 'VENDOR', class: { '!bg-yellow-100': true, '!text-yellow-800': true } } // Vendor: Màu vàng
    ],
    filterModelDefault: { type: 'equals', filterType: 'text' }
  },
  {
    field: 'statusConfirmMarkup',
    headerName: $t('labels.markupApprovalMarkup'),
    cellRenderer: Status,
    cellRendererParams: {
      module: 'partnerStatusConfirmMarkup',
      label: '',
      keyStatus: 'statusConfirmMarkup'
    },
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      { name: $t('labels.pendingApproval'), value: 0, class: { '!bg-yellow-100': true, '!text-yellow-800': true } }, // Pending Approval: Màu vàng
      { name: $t('labels.approved'), value: 1, class: { '!bg-green-100': true, '!text-green-800': true } }, // Approved: Màu xanh lá cây
      { name: $t('labels.reject'), value: 2, class: { '!bg-red-100': true, '!text-red-800': true } } // Reject: Màu đỏ
    ],
    filterModelDefault: { type: 'equals', filterType: 'number' }
  },
  {
    field: 'markup',
    headerName: $t('labels.markup'),
    valueFormatter: (params: any) => {
      if (!params?.data?.type.includes('CUSTOMER')) {
        return ''
      }
      const statusConfirmMarkup = params?.data?.markup
      if (typeof statusConfirmMarkup === 'number') {
        return `${statusConfirmMarkup}%`
      }
    }
  },
  {
    field: 'customerStatus',
    headerName: $t('labels.customerStatus'),
    cellRenderer: Status,
    cellRendererParams: {
      module: 'customerStatus',
      label: '',
      keyStatus: 'customerStatus'
    },
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      { name: 'Lead', value: 1, class: { '!bg-blue-100': true, '!text-blue-800': true } }, // Lead: Màu xanh dương
      { name: 'Prospect', value: 2, class: { '!bg-blue-100': true, '!text-blue-800': true } }, // Prospect: Màu xanh dương
      { name: 'Opportunity', value: 3, class: { '!bg-blue-100': true, '!text-blue-800': true } }, // Opportunity: Màu xanh dương
      { name: 'Customer', value: 4, class: { '!bg-pink-100': true, '!text-pink-800': true } } // Customer: Màu hồng
    ],
    filterModelDefault: { type: 'equals', filterType: 'number' }
  },
  {
    field: 'statusJoinSystem',
    headerName: 'Trạng thái tham gia hệ thống',
    autoHeight: true,
    wrapText: true,
    cellRenderer: SystemParticipationStatus,
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      { name: 'Chưa mời', value: 0, class: { '!bg-red-100': true, '!text-red-800': true } }, // Chưa mời: Màu đỏ
      { name: 'Chờ xác nhận', value: 1, class: { '!bg-yellow-100': true, '!text-yellow-800': true } }, // Chờ xác nhận: Màu vàng
      { name: 'Đã tham gia', value: 2, class: { '!bg-green-100': true, '!text-green-800': true } } // Đã tham gia: Màu xanh lá cây
    ],
    filterModelDefault: { type: 'equals', filterType: 'number' }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    popup: true,
    suppressRowTransform: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: actions,
    cellRendererParams: {
      storeKey: 'cooperatorDataTable',
      storeName: 'Cooperator',
      items: [
        {
          icon: 'hi-pencil-square-icon',
          label: $t('labels.edit'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_edit),
          click: handleEditCustomer
        },
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewDetail'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_management),
          click: handleViewDetailCustomer,
          isAll: true
        },
        {
          icon: 'hi-document-text-icon',
          label: $t('labels.viewDocument'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_document_management),
          click: handleShowDocumentCooperator
        },
        {
          icon: 'hi-shopping-cart-icon',
          label: $t('labels.viewCommodity'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_commodity_management),
          validate: validateListCommodity,
          click: openListCommodity
        },
        {
          icon: 'hi-arrow-trending-up-icon',
          label: $t('labels.businessOpportunity'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_business_opportunity_management),
          validate: validateListBusinessOpportunity,
          click: openListBusinessOpportunity
        },
        {
          icon: 'hi-inbox-stack-icon',
          label: $t('labels.viewContact'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_contact_management),
          click: openListContact
        },
        {
          icon: 'hi-inbox-stack-icon',
          label: $t('labels.viewInvoicingInformation'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_contact_management),
          click: openListInvoicingInformation
        },
        {
          icon: 'hi-banknotes-icon',
          label: $t('labels.viewBankAccount'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_bank_management),
          click: openListBank
        },
        {
          icon: 'hi-clock-icon',
          label: $t('labels.taskInformation'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_task_completion_time_management),
          validate: validateListCommodity,
          click: openTaskCompletionTime
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: checkPermission(layoutPermissions.partner_delete),
          click: handleDeleteCustomer,
          isArchive: true
        }
      ]
    }
  }
])

const actionDeleteCustomer = () => {
  const api = $url.partner['partner-delete']

  $api(api, { body: { ids: [customerIsSelectedForDelete.value?._id || ''] } }).then((data: any) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      customerIsSelectedForDelete.value = null
      refreshTables()
      showPopupDeleteCustomer.value = false
      process.client && $toast().success($t('labels.deleteSuccess', { name: $t('labels.partner') }))
    }
  })
}
const useArchive = { api: $url.partner.archive, permissions: checkPermission(layoutPermissions.partner_archive) }
const useRestore = { api: $url.partner.restore, permissions: checkPermission(layoutPermissions.partner_restore) }
</script>
